import React, { useEffect, useState, useLayoutEffect } from "react"
import { Box, Container, Flex, Grid, Heading, Text, Image } from "theme-ui"
import RichContentStructuredText from "./richContentStructuredText"
import CountUp from "react-countup"
import { useInView } from "react-intersection-observer"
import AnimateText from "./animateText"
import SlideInComponent from "./slideInComponent"
import HomeImageMobile from "../images/home-mobile-2.png"

const HomeAboutUsPartTwo = ({ block }) => {
  const [selected, setSelected] = useState(0)
  const { aboutUsNumbers } = block

  return (
    <Box
      sx={{ mb: [3, 4, 4, 5], height: "100%", backgroundColor: "primary" }}
      className="home_animation_two_container"
    >
      <Grid columns={[1, 1, 2, 2]} gap={0} sx={{ height: "100%" }}>
        <Box>
        <Image sx={{
          display:["block","block","none"],
          maxWidth:"90%"
        }} src={HomeImageMobile} />
        </Box>
        <Container
          sx={{
            p: { fontSize: [3, 3, 3, 4] },
            height: "100%",
            width: "100%",
            alignItems: "space-between",
            pt: [6,6,9, 9],
            display: "flex",
          }}
        >
          <Box
            sx={{
              width: "100%",
              p: {
                fontSize: [2, 3],
                fontFamily: "roc",
              },
            }}
          >
            {aboutUsNumbers &&
              aboutUsNumbers.map((number, index) => (
                <Box
                  className="text"
                  sx={{
                    width: "100%",
                  }}
                >
                  <Number number={number} selected={selected === index} />
                </Box>
              ))}
          </Box>
        </Container>
      </Grid>
    </Box>
  )
}

const Number = ({ number, selected }) => {
  const [startCount, setStartCount] = useState(false)
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView === true && startCount === false) {
      setStartCount(true)
    }
  }, [inView])

  return (
    <Flex
      className="number"
      ref={ref}
      sx={{
        justifyContent: "space-between",
        marginBottom: [2],
        borderTop: "1px solid",
        borderColor: "light",
        flexDirection:["column","row","row"]
      }}
    >
      <Box>
        <Text
          sx={{
            marginTop: 0,
            marginBottom: 0,
            color: "light",
            opacity: 1,
            fontSize: ["10rem"],
            lineHeight: 1,
            transition: "opacity .3s ease-in-out",
          }}
        >
          <SlideInComponent>
            <CountUp
              end={number.float}
              prefix={number.prefix ? `${number.prefix}` : null}
              suffix={number.suffix ? `${number.suffix}` : null}
              start={startCount}
            />
          </SlideInComponent>
        </Text>
      </Box>
      <Flex
        sx={{
          alignItems: "center",
        }}
      >
        <AnimateText
          type="text"
          as="p"
          sx={{
            maxWidth: "225px",
            fontFamily: "roc",
            fontSize: [2, 3, 3, 3],
            textAlign: "right",
            color: "light",
          }}
        >
          {number.legend}
        </AnimateText>
      </Flex>
    </Flex>
  )
}

export default HomeAboutUsPartTwo
